// import React from 'react';
import { useSearchParams } from 'react-router-dom';
import '../../Modal/modal.css';
import PearsonLogo from '../../../../images/pearson_logo.png';
import deleteButton from '../../../../images/delete.jpg';


const DeleteFolder = ({ showDeleteModal, setShowDeleteModal, filesToDelete, confirmDelete, currentPath }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    // Close modal popup
    const onModalpopupClose = () => {
        if (searchParams.has('delete')) {
            searchParams.delete('delete');
            setSearchParams(searchParams);
        }
        setShowDeleteModal(false);
    };
    
    let storedDirectoriesListDelete = JSON.parse(localStorage.getItem('directoriesListDelete'));

    const results = filesToDelete.map(fileName => {
        const foundItem = storedDirectoriesListDelete.find(item => item.directory === fileName);
        return {
          fileName,
          exists: !!foundItem, 
          isFile: foundItem ? foundItem.isFile : null 
        };
      });
      
    const directory = results.filter(file => !file.isFile);
    const files = results.filter(file => file.isFile); 

    const formattedPath = currentPath.replace(/%20/g, ' ');

    return (
        <div className="modal-content-table">
            <table role="presentation" border="0" width="99%" cellSpacing="3" cellPadding="0">
                <tr align="left" valign="top">
                    <td align="left" valign="middle">
                        <span className="pagetitle">&nbsp;Soft-delete Folders/Files</span>
                    </td>
                    <td align="right" valign="middle">
                        <img src={PearsonLogo} title="Pearson Education" alt="Pearson Education" width="85" height="21" hspace="0" vspace="0" border="0" />
                    </td>
                    <td>
                        <span className="close" onClick={onModalpopupClose}>&times;</span>
                    </td>
                </tr>
            </table>
            <div id="background" className='create-new-folder'></div>
            <div id="table" className='unzip-table' >
                <table role="presentation" border="0" width="99%" cellSpacing="0" cellPadding="0">
                    <tr align="left" valign="top">
                        <td align="left" valign="top" width="90" className='delete-folder-color'>
                            <img src={deleteButton} alt="New Folder" width="60" height="56" border="0" className='delete-icon' />
                        </td>
                        <td align="center" valign="top" className="instructions delete-folder-modal-main">
                            <div className="delete-folder-modal-copy-delete">
                                <p className="delete-folder-note">
                                     <strong>Note:</strong>{' '}
                                     <strong className="delete-folder-alert-text">
                                       Deleted files/folders can be restored from &apos;View Deleted Items&apos; within 30 days.
                                       After that period, they are permanently deleted.
                                     </strong>
                                </p>
                                <p className="delete-folder-path">
                                 <strong>Directory :</strong><strong className="delete-folder-path-text">{formattedPath}</strong>
                                </p>
                            </div>
                            <div
                                className="delete-folder-lists"
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'center',
                                    gap: '24px',
                                    textAlign: 'center',
                                }}
                            >
                                {directory.length > 0 && (
                                    <div>
                                        <h3 className="delete-folder-list-heading">Directory:</h3>
                                        <ul className="delete-folder-list">
                                            {directory.map((directory, index) => (
                                                <li key={index}>
                                                    <strong>
                                                        {index + 1}. {directory.fileName}
                                                    </strong>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {files.length > 0 && (
                                    <div>
                                        <h3 className="delete-folder-list-heading">Files:</h3>
                                        <ul className="delete-folder-list">
                                            {files.map((file, index) => (
                                                <li key={index}>
                                                    <span style={{ fontWeight: 'bold' }}>
                                                        {index + 1}. {file.fileName}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                            <div className="delete-folder-actions">
                                <input
                                    type="button"
                                    className="unzip-formButton"
                                    value="&nbsp;Cancel&nbsp;"
                                    onClick={onModalpopupClose}
                                />
                                <input
                                    type="button"
                                    className="unzip-formButtonGo"
                                    value="&nbsp;&nbsp;Delete&nbsp;&nbsp;"
                                    onClick={confirmDelete}
                                />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    );
};

export default DeleteFolder;
